//auth
export const LOGIN = 'LOGIN';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const RESET_PASSWORD = 'RESET_PASSWORD';
// Master data
export const GET_MASTER_DATA = 'GET_MASTER_DATA';

//dashboard
export const DASHBOARD_TOP = 'DASHBOARD_TOP';
export const DASHBOARD_PROJECT_OVERVIEW = 'DASHBOARD_PROJECT_OVERVIEW';
export const DASHBOARD_JOB_MOTHLY = 'DASHBOARD_JOB_MOTHLY';
export const DASHBOARD_PROJECT_REVENUE = 'DASHBOARD_PROJECT_REVENUE';

//job
export const GET_JOBS = 'GET_JOBS';
export const GET_BOARD_COUNT = 'GET_BOARD_COUNT';
export const MOVE_STAGE = 'MOVE_STAGE';
export const CREATE_JOB = 'CREATE_JOB';
export const UPDATE_JOB = 'UPDATE_JOB';
export const DELETE_JOB = 'DELETE_JOB';

// job details
export const GET_JOB_DETAILS = 'GET_JOB_DETAILS';
export const GET_OVERVIEW_JOB_DETAILS = 'GET_OVERVIEW_JOB_DETAILS';
export const UPDATE_OVERVIEW_JOB_DETAILS = 'UPDATE_OVERVIEW_JOB_DETAILS';
export const GET_OVERVIEW_CUSTOMER_DETAILS = 'GET_OVERVIEW_CUSTOMER_DETAILS';
export const GET_OVERVIEW_ACTIVITY_FEED = 'GET_OVERVIEW_ACTIVITY_FEED';
export const UPDATE_OVERVIEW_CUSTOMER_DETAILS = 'UPDATE_OVERVIEW_CUSTOMER_DETAILS';
export const JOB_DETAILS_ADD_CONTACT = 'JOB_DETAILS_ADD_CONTACT';
export const GET_OVERVIEW_JOB_TASK_LIST = 'GET_OVERVIEW_JOB_TASK_LIST';
export const CREATE_JOB_TASK = 'CREATE_JOB_TASK';
export const UPDATE_JOB_TASK = 'UPDATE_JOB_TASK';
export const GET_INVOICE_JOB_DETAILS_LIST = 'GET_INVOICE_JOB_DETAILS_LIST';
export const CREATE_INVOICE = 'CREATE_INVOICE';
export const GET_PAYMENT_JOB_DETAILS_LIST = 'GET_PAYMENT_JOB_DETAILS_LIST';
export const GET_LIST_BUDGET_TRACKER_JOB_DETAILS = 'GET_LIST_BUDGET_TRACKER_JOB_DETAILS';
export const GET_LIST_CREDIT_MEMO_JOB_DETAILS = 'GET_LIST_CREDIT_MEMO_JOB_DETAILS';
export const CREATE_CREDIT_MEMO = 'CREATE_CREDIT_MEMO';
export const UPDATE_CREDIT_MEMO = 'UPDATE_CREDIT_MEMO';
export const TOGGLE_ARCHIVED_BUDGET_TRACKER = 'TOGGLE_ARCHIVED_BUDGET_TRACKER';

//job-estimate
export const ADD_ESTIMATE = 'ADD_ESTIMATE';
export const GET_ESTIMATE = 'GET_ESTIMATE';
export const GET_ESTIMATE_DETAIL = 'GET_ESTIMATE_DETAIL';
export const UPLOAD_ESTIMATE = 'UPLOAD_ESTIMATE';
export const EDIT_ESTIMATE = 'EDIT_ESTIMATE';
export const DELETE_ESTIMATE = 'DELETE_ESTIMATE';


export const GET_OVERVIEW_WORK_ORDER_LIST = 'GET_OVERVIEW_WORK_ORDER_LIST';
//job-photo
export const GET_PHOTO = 'GET_PHOTO';
export const GET_PHOTO_DETAIL = 'GET_PHOTO_DETAIL';
export const UPLOAD_PHOTO = 'UPLOAD_PHOTO';
export const EDIT_PHOTO = 'EDIT_PHOTO';
export const DELETE_PHOTO = 'DELETE_PHOTO';


// Job type
export const GET_JOB_TYPES = 'GET_JOB_TYPES';

// Tag
export const GET_TAGS = 'GET_TAGS';

// Account
export const GET_SELECT_ACCOUNTS = 'GET_SELECT_ACCOUNTS';
export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';
export const GET_ACCOUNTS = 'GET_ACCOUNTS';
export const GET_ACCOUNT = 'GET_ACCOUNT';
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';

//time-clocks
export const GET_TIME_CLOCKS = 'GET_TIME_CLOCKS';

//schedule
export const GET_SCHEDULE_EVENTS = 'GET_SCHEDULE_EVENTS';
export const ADD_SCHEDULE_EVENT = 'ADD_SCHEDULE_EVENT';
export const UPDATE_SCHEDULE_EVENT = 'UPDATE_SCHEDULE_EVENT';

// CRM
export const GET_CRM_LIST_VIEW = 'GET_CRM_LIST_VIEW';
export const CREATE_CRM_LEAD = 'CREATE_CRM_LEAD';
export const GET_CLIENT_DETAILS = 'GET_CLIENT_DETAILS';
export const GET_DOCUMENTS = 'GET_DOCUMENTS';
export const UPLOAD_FILE = 'UPLOAD_FILE';
export const GET_CUSTOMER_JOBS = 'GET_CUSTOMER_JOBS';
export const ADD_NOTE = 'ADD_NOTE';
export const GET_ACTIVITIES = 'GET_ACTIVITIES';

// estimate setting
export const GET_ESTIMATE_LAYOUTS = 'GET_ESTIMATE_LAYOUTS';
export const CREATE_ESTIMATE_LAYOUT = 'CREATE_ESTIMATE_LAYOUT';
export const GET_ESTIMATE_TEMPLATES = 'GET_ESTIMATE_TEMPLATES';
export const CREATE_INTRODUCTION_TEMPLATE = 'CREATE_INTRODUCTION_TEMPLATE';
export const CREATE_DETAILS_TEMPLATE = 'CREATE_DETAILS_TEMPLATE';
export const CREATE_SIGNING_UPGRADES = 'CREATE_SIGNING_UPGRADES';
export const GET_ESTIMATE_TEMPLATE_INTRODUCTION = 'GET_ESTIMATE_TEMPLATE_INTRODUCTION';
export const GET_ESTIMATE_TEMPLATE_AUTHORIZATION = 'GET_ESTIMATE_TEMPLATE_AUTHORIZATION'

// SMS Communication
export const GET_SMS_CONVERSATIONS = 'GET_SMS_CONVERSATIONS';
export const GET_SMS_MESSAGES = 'GET_SMS_MESSAGES';
export const SEND_SMS = 'SEND_SMS';
export const UPDATE_SMS_CONVERSATION = 'UPDATE_SMS_CONVERSATION';
export const GET_SMS_CONTACT_DETAILS = 'GET_SMS_CONTACT_DETAILS';
